import React from "react";
import Footer from "../components/Footer";
import Navbaartesting from "../components/Navbaartesting";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { Link } from "react-router-dom";
import styled from "styled-components";
import CampusTourImg from "../school_images/hostel.jpeg";
import Image11 from "../school_images/event_1_.jpg";

const Lifeatgdgps = () => {
  return (
    <div>
      <Navbaartesting />
      <MainImageDiv>
        <img src={CampusTourImg} alt="Career_image" className="w-full" />
        <SocialMediaIconsDiv>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.facebook.com/gdgoenkadarbhanga/"
              target="_blank"
            >
              <FaFacebook />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.youtube.com/channel/UCyG9n-Bbb75mEgQ5FWLtggg"
              target="_blank"
            >
              <IoLogoYoutube />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.instagram.com/gdgoenkadarbhanga"
              target="_blank"
            >
              <FaInstagramSquare />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3 ">
            <Link
              to="https://www.linkedin.com/in/gd-goenka-darbhanga-b88430217"
              target="_blank"
            >
              <IoLogoLinkedin />
            </Link>
          </div>
        </SocialMediaIconsDiv>
      </MainImageDiv>

      <LifeAtGDGPSContainer>
        <h2 className="mb-6">
          WITH THE OBJECTIVE OF RAISING CHILDREN INTO FINE HUMAN BEINGS,
          INNOVATIVE AGE APPROPRIATE PEDAGOGICAL PRACTICES HAVE BEEN DEVELOPED
          THAT FOCUS ON INGRAINING SOUND VALUE SYSTEM IN STUDENTS.
        </h2>
        <p>
          Since children at different ages have different learning patterns, the
          value based pedagogical practices for classes Nursery to II comprise
          of generating awareness and sensitivity about Ecology & Culture of our
          own country and that of other nations. In classes III to V, focus is
          on developing their language and expression. Going forward in classes
          VI to VIII they are provided with a platform to absorb, reflect and
          express through integration of Creative & Performing Arts and YOGA.
        </p>

        <h2>INNOVATIVE SKILL & VALUE BASED PEDAGOGICAL PRACTICES</h2>
        <CardContainer>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> ECVS - ECOLOGY, CULTURE VALUES & SKILLS PROGRAMME</h2>
              <h3 className="text-3xl font-light">CLASSES Nursery TO II</h3>
            </div>
            <hr></hr>
            <hr></hr>
            <p>
              Rhymes, Songs, hands-on activities, role plays, enactments and
              story-telling centering around key components of ECVS.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> VASP – VALUE ADDITION BY SCHOOL PARENTS</h2>
              <h3 className="text-3xl font-light">CLASSES NURSERY TO II</h3>
            </div>
            <p>
              Schools in collaboration with parents work together supporting the
              very cause of value addition in our children through activities,
              sessions, games and interactions.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> VLEP - VALUES & LANGUAGE ENHANCEMENT PROGRAMME</h2>
              <h3 className="text-3xl font-light">CLASSES III TO V</h3>
            </div>
            <p>
              Making children learn values through special language activities
              like word game, vocabulary game, comprehensions, story-telling,
              value-based children’s films, presentations, self reflecting
              activities, discussions and group work.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> VVAP – VALUES & VISUAL ARTS PROGRAMME</h2>
              <h3 className="text-3xl font-light">CLASSES VI TO VIII</h3>
            </div>

            <p>
              Values and skills integrated with Visual Arts and Yoga sessions is
              an experiential and participatory approach pedagogical practice
              through which children introspect; express views, ask questions,
              seek clarity and learn from a variety of thought provoking
              activities.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> SCIENCE | TECHNOLOGY | ENGINEERING | MATHS</h2>
              <h3 className="text-3xl font-light">STEM :NURSERY TO XII</h3>
            </div>

            <p>
              An Innovative Pedagogical Practice enabling students to explore
              the interconnectivity of Science, Technology, Engineering and
              Mathematics through real-life situations. STEM occupations are
              growing exponentially. Goenkans are made future ready as most
              future jobs require conceptual understanding of Mathematics and
              Science.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2>
                {" "}
                CULTURE | LANGUAGES | ARTS | SOCIAL ISSUES | SOCIAL SCIENCE
              </h2>
              <h3 className="text-3xl font-light">CLASS : III TO XII</h3>
            </div>
            <hr></hr>
            <hr></hr>
            <p>
              Amalgamates Culture, Languages, Arts, Social issues, Social
              Science and Values into a comprehensive subject week. Encompassing
              all subjects, the objective is to understand the interdependence
              of each component through group discussions and project
              presentations.
            </p>
          </Card1>
          <Card1>
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> INTEGRATED CREATIVE LEARNING PROGRAMME</h2>
              <h3 className="text-3xl font-light">ICLP : VIII</h3>
            </div>

            <p>
              Integrates the Scholastic with the Co scholastic and makes the
              learning of Science, Mathematics and Literature more
              application-based, effective & experiential through integration of
              the two domains
            </p>
          </Card1>

          <Card1 className="min-h-[615px]">
            <img src={Image11} alt="jhgsda" />
            <div className="border-b-2 border-rose-950 text-center pb-4">
              <h2> GRACIOUS GOENKAN</h2>
              <h3 className="text-3xl font-light">NUR to XII</h3>
            </div>

            <p>
              Students are encouraged to self evaluate , reflect and think
              abouut their work habits, behaviour and value based learning. This
              helps them believe in the power of goodness and continue being on
              the correct path and stay connected to our roots.
            </p>
            <p>
              The students are awarded a Gracious Goenkan certificate ,
              recognising them for being good, helpful, kind and for the values
              the have imbibed
            </p>
          </Card1>
        </CardContainer>
        <GoenkaMun>
          <h1>THE GOENKAN MUN</h1>
          <img src={Image11} alt="kjsdhfk" />
          <p>
            {" "}
            Model United Nations is an activity that encompasses elements of
            traditional debating along with global and more intensive research,
            as it relates to real world issues discussed at the United Nations.
            This activity has become a crucial co-scholastic activity that
            broadens students’ horizons. In MUN’s, students participate as
            delegates representing different nations and put forth views on this
            basis. It serves to increase students' overall international
            awareness on crucial issues that are likely to be discussed on a
            global platform such as the United Nations, as well as to increase
            their skills with debating and research. It makes our student’s
            effective communicators who get to develop their confidence and
            speaking skills through this activity. These skills are transferable
            from a competitive MUN context, to other engagements which students
            are likely to encounter in their academic and professional life,
            such as giving interviews or taking part in group discussions. It
            helps to broaden their horizon and make them better human beings and
            leaders. The topics are so divergent that it enhances the student’s
            sensitization to the world that they live in. It helps to broaden
            their analytical and evaluative skills.
          </p>
          <p>
            Goenkans have shown a keen interest in MUN’s. Each year, we witness
            an enthusiastic participation by our students. It’s a matter of
            pride that apart from hosting The Goenka Model United Nations
            Conference, our students have been winning accolades for each MUN
            they participate in. Their conviction reaffirms our belief in the
            power of positive and persuasive dialogue.
          </p>
        </GoenkaMun>
        <ImageTextDiv>
          <TextDiv>
            <h2>TEACHERS’ DAY CELEBRATIONS</h2>
            <p>
              ‘A teacher is a magnet that activates the magnets of curiosity,
              wisdom and knowledge.’
            </p>
            <p>
              Teachers’ Day is a day which both teachers and students look
              forward to. It is not just the commemoration of the birth date of
              one of the finest teachers of India, Dr. Sarvapalli Radhakrishnan,
              but is also a celebration of the teaching profession itself. After
              the students warmly greet their teachers, they bring pleasant
              surprises for them by way class decorations and class parties.
              Each and every class is decorated with balloons, buntings and
              special messages written on the boards to express their love for
              their teachers. It is rightly said, “To the world you may be just
              a teacher but to your students you are a hero.”
            </p>
          </TextDiv>
          <ImageDiv>
            <img src={Image11} alt="kjsdhfk" />
          </ImageDiv>
        </ImageTextDiv>
        <p>
          To pay gratitude towards the quintessential roles of the Goenkan
          teachers in spearheading a positive change in their lives, the
          students of Grade XII put up a heart-warming cultural programme for
          the school principal and the teachers that include dance preformaces,
          medley of songs, bollywood based quizzes, short videos made by
          students and other engaging activities. The students also acknowledge
          the special attributes of each and every teacher by giving them
          customized titles like ‘English Wizard’, ‘Maths Genius’, ‘Dancing
          Diva’, ‘Nimble Fingers’ to name a few. The cultural program conveys
          the entire gamut of emotions that the Goenkan students have for their
          teachers – love, respect, trust and faith.
        </p>
        <ImageTextDiv>
          <ImageDiv>
            <img src={Image11} alt=" sjhflks" />
          </ImageDiv>
          <TextDiv>
            <h2>FAREWELL</h2>
            <p>
              Showers of blessings, ceremonial good-byes, fond wishes, inspiring
              words, nostalgic moments and expressions of gratitude are the
              special ingredients that make up the Citation and Farewell
              Ceremony held each academic year for Grade XII students in GDGPS,
              Secs-48. Nostalgia engulfs the out-going batch when they walk
              through the beautifully decorated corridors and class-rooms
              bedecked with adieu and au revoir messages prepared by their
              junior students of Grade XI. The stately Citation Ceremony,
              sculpted out of love, is a sincere acknowledgement of each
              student’s unique personality. It encapsulates in poignant words
              the milestones and best moments of their school saga. A
              significant part of the ceremony is the handing over of the diya
              of knowledge by Grade XII students to their immediate juniors of
              Grade XI. It signifies that not only had they passed on the flame
              of knowledge to their juniors but also bestowed the baton of
              responsibility upon them. The class teachers read aloud the
              citations of each and every student.
            </p>
          </TextDiv>
        </ImageTextDiv>
        <p>
          An informal Valedictory Function is hosted by the Grade XI students in
          the afternoon after the lunch. Standup comedy, sparkling spoofing and
          well-coordinated dance performances on a medley of foot-tapping
          numbers are some of the high points of the evening’s party. The witty
          titles given to each student of Grade XII along with the special
          awards such as Pride of Goenka, Goenka in Vogue, Face of Goenka, Ms
          and Mr Popular and Ms and Mr Goenka are the coup de grace of the
          farewell party. The students of passing out batch express their
          gratitude to the Principal, Headmistresses, their teachers and school
          for building their characters and nurturing their abilities.
        </p>
        <ImageTextDiv>
          <TextDiv>
            <h2>CONNECT </h2>
            <p>
              Connect is another unique initiative of GDGPS Sec-48. It is a part
              of the school culture that celebrates and thrives on its strong
              connections with the faculty members and their families. It is the
              school management’s special acknowledgement of the pivotal role
              played by the families and spouses of their teachers that gives
              CONNECT its special dimensions, dynamics and soul. Through
              Connect, conceptualized in the first year of school’s inception,
              the school celebrates, confirms and cherishes the connection
              between the Goenkan fraternity and the families of the entire
              staff. All the teachers and their families are smilingly greeted
              by the Principal and the Headmistresses followed by performances
              by a few teachers and engaging sessions like singing, dancing,
              group games, interactive & bonding time activities in the school
              auditorium. After the engaging activities, principal and incharges
              mingle with the staff and their families over a sumptuous dinner,
              thus creating a fresh repository of moments of togetherness.
            </p>
          </TextDiv>
          <ImageDiv>
            <img src={Image11} alt="jhdsfgkjhfds" />
          </ImageDiv>
        </ImageTextDiv>
      </LifeAtGDGPSContainer>
      <Footer />
    </div>
  );
};

export default Lifeatgdgps;

const GoenkaMun = styled.div`
  img {
    max-width: 500px;
  }
`;

const Card1 = styled.div`
  width: 49%;

  min-height: 650px;
  border: 2px solid red;
  background-color: #eee;

  margin-bottom: 1rem;
  img {
    width: 100%;
    height: auto;
    max-height: 300px;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const CardContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: Space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    margin-top: 1rem;
  }
`;

const LifeAtGDGPSContainer = styled.div`
  padding: 0% 7%;
  text-align: left;
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 300;
    padding: 1%;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
  h2 {
    font-weight: 340;
    font-size: 35px;
    @media (max-width: 500px) {
      font-size: 20px;
    }
  }
  h3 {
    @media (max-width: 500px) {
      font-size: 18px;
    }
  }
  h1 {
    font-size: 50px;
    text-transform: uppercase;
    text-decoration: underline;
    margin-bottom: 1rem;
    font-weight: 600;
    @media (max-width: 500px) {
      font-size: 30px;
    }
  }
`;

const MainHeading = styled.span`
  position: absolute;
  bottom: 10%;
  right: 10%;
  color: #2c975b;
  font-size: 50px;
`;

const MainImageDiv = styled.div`
  padding: 0 0%;
  max-height: 500px;
  min-height: 330px;
  position: relative;
  img {
    max-height: 500px;
    height: 100%;
    width: 100%;
    min-height: 330px;
  }
`;

const SocialMediaIconsDiv = styled.span`
  color: #fff;
  position: absolute;
  top: 20%;
  right: 2%;
  a {
    color: #fff;
    font-size: 30px;
    &:hover {
      color: brown;
    }
  }
  div {
    @media (max-width: 640px) {
      font-size: 25px;
      width: 45px;
      height: 45px;
    }
  }
`;

const ImageTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 700px) {
    flex-direction: column;
  }
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
`;

const ImageDiv = styled.div`
  width: 50%;
  height: auto;
  min-height: 300px;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const TextDiv = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  text-align: left;
  @media (max-width: 700px) {
    width: 100%;
  }
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
`;
